import ProfileUnlockServices from "../../services/profileUnlock";
import fileService from "../../services/file";

const getDefaultState = () => {
  return {

  }    
}
const state = getDefaultState()

const getters = {  

};

const actions = {
    DownloadList(st, data) {
      return ProfileUnlockServices.DownloadList(st.rootState.auth.idToken, data);
    },
    DownloadFile(st, data){
      return fileService.DownloadFile(st.rootState.auth.idToken, data);
    }
};

const mutations = {
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};